import { Tooltip, withStyles } from "@material-ui/core";

const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#EAEBF0',
      color: '#6F7984',
      fontSize: 11,
      borderRadius: 0,
    },
  }))(Tooltip);

  export default LightTooltip